<!-- Header -->
<div class="upload-header" *ngIf="title || showCounter">
  <div class="header-title">
    <p>{{ title }}</p>
    <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
  </div>
  <span class="header-counter" *ngIf="showCounter">{{ files?.length ?? 0 }} / {{ maxFilesCount }}</span>
</div>
<!-- Upload area -->
<div
  *transloco="let t"
  class="file-upload-area"
  [class.drag-over]="isDragging$ | async"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div class="file-upload-content" *ngIf="files?.length === 0">
    <button type="button" class="btn btn-outline-primary btn-icon" (click)="fileInput.click()" [disabled]="loading">
      <ng-content select=".add"></ng-content>
    </button>
    <ng-content select=".hint"></ng-content>
  </div>

  <div class="uploaded-files" *ngIf="files?.length">
    <div class="uploaded-file-item" *ngFor="let file of files; let i = index">
      <div class="file-info">
        <!-- Image -->
        <ng-container *ngIf="file.data.type === 'image'">
          <img [src]="file.fileSafeUrl" alt="" class="file-img" />
        </ng-container>
        <!-- Video -->
        <ng-container *ngIf="file.data.type === 'video'">
          <i class="material-symbols-rounded file-video">video_file</i>
        </ng-container>
        <!-- Document -->
        <ng-container *ngIf="file.data.type === 'document'">
          <i class="material-symbols-rounded file-document">file_present</i>
        </ng-container>

        <div class="file-details">
          <span class="file-name">{{ file.name }}</span>
          <span class="file-size">{{ file.size }}</span>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-remove"
        (click)="
          removeFile.emit({
            index: i,
            fileId: file.data.id
          })
        "
      >
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>
    <button
      *ngIf="files?.length < maxFilesCount"
      type="button"
      class="btn btn-outline-primary"
      (click)="fileInput.click()"
      [disabled]="loading"
    >
      <i class="material-symbols-rounded">add</i>
      <span>{{ t('childrenPortfolio/record/addMoreFiles') }}</span>
    </button>
  </div>

  <input
    #fileInput
    type="file"
    multiple
    [accept]="accept"
    class="file-input-hidden"
    (change)="onFileSelected($event)"
    style="display: none"
  />
</div>
